/**
 *
 * ComboBoxCreator
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import createComboBoxContainer from './createComboBoxContainer';

class ComboBoxCreator extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const ComboBoxContainer = createComboBoxContainer(this.context.advancedForm, this.props.name);
    return <ComboBoxContainer {...this.props} />;
  }
}

ComboBoxCreator.contextTypes = {
  advancedForm: PropTypes.string.isRequired,
};

ComboBoxCreator.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ComboBoxCreator;